import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-in-canada',
  templateUrl: './shop-in-canada.component.html',
  styleUrls: ['./shop-in-canada.component.css']
})
export class ShopInCanadaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
